<template>
  <div class="balloon-container">
    <audio autoplay loop>
      <source
        :src="'https://jkmd.kevinreynaufal.com/sound.mp3'"
        type="audio/ogg"
      />
    </audio>

    <div
      v-for="index in numBalloons"
      :key="index"
      class="balloon"
      :style="getBalloonStyles(index)"
    ></div>
    <h1 class="birthday-title">Happy Birthday Bos IT</h1>

    <div class="gallery">
      <img
        :src="'https://cdn.efund.id/projects/project_image1731412092.jpeg'"
        alt="a lovely kiss in the night"
      />
      <img
        :src="'https://cdn.efund.id/projects/project_image1731412094.jpeg'"
        alt="a lovely kiss in the night"
      />
      <img
        :src="'https://cdn.efund.id/projects/project_image1731412096.jpeg'"
        alt="a lovely kiss in the night"
      />
      <img
        :src="'https://cdn.efund.id/projects/project_image1731412099.jpeg'"
        alt="a lovely kiss in the night"
      />
      <img
        :src="'https://cdn.efund.id/projects/project_image1731412101.jpeg'"
        alt="a lovely kiss in the night"
      />
      <img
        :src="'https://cdn.efund.id/projects/project_image1731412104.jpeg'"
        alt="a lovely kiss in the night"
      />
    </div>

    <h2 class="birthday-title" style="margin-top: 3rem">
      Adittya Subagaja 26 tahun
    </h2>

    <p style="text-align: center">
      Panjang umur Pa Adit Sehat selalu. Di lancarkan rejekinya, dan <br />
      Semoga BMW M4 nya cepat tercapai yaaa
    </p>
  </div>
</template>
<script src="https://www.youtube.com/iframe_api"></script>
<script>
export default {
  mounted() {
    // Load the YouTube Iframe API script
    this.loadYouTubePlayer();

    // Automatically play the video after the timeout
    this.startVideoAfterTimeout();
  },
  data() {
    return {
      numBalloons: 20, // Number of balloons to generate,
      player: null, // This will hold the YouTube player instance
      timeoutDuration: 1000
    };
  },
  methods: {
    // This method is used to load the YouTube Iframe player
    loadYouTubePlayer() {
      // console.log("test");
      window.onYouTubeIframeAPIReady = () => {
        this.player = new YT.Player("player", {
          events: {
            onReady: this.onPlayerReady,
            onStateChange: this.onPlayerStateChange
          }
        });
      };
    },

    // This method will be called when the player is ready
    onPlayerReady(event) {
    },

    // This method will be called on state change (e.g., video ends, starts, etc.)
    onPlayerStateChange(event) {
      // Handle different player states if necessary
      if (event.data === YT.PlayerState.ENDED) {
      }
    },

    // Start playing the video automatically after a timeout
    startVideoAfterTimeout() {
      setTimeout(() => {
        if (this.player) {
          // console.log("Playing video after timeout...");
          this.player.playVideo(); // Play the video after the timeout
        }
      }, this.timeoutDuration); // Delay in milliseconds
    },

    // Get random styles for each balloon
    getBalloonStyles(index) {
      const randomX = Math.random() * 100 - 50 + "vw"; // Random horizontal movement (left or right)
      const randomDelay = Math.random() * 2 + "s"; // Random start delay for animation
      const randomDuration = Math.random() * 4 + 6 + "s"; // Random animation duration (between 6s and 10s)

      // Random colors for balloons
      const colors = ["#ff6347", "#ffb6c1", "#add8e6", "#90ee90", "#ffde00"];
      const randomColor = colors[Math.floor(Math.random() * colors.length)];

      return {
        backgroundColor: randomColor,
        animationDelay: randomDelay,
        animationDuration: randomDuration,
        "--random-x": randomX
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/thank_you.scss";
</style>
<style scoped>
/* styles.css */

.birthday-title {
  text-align: center;
  font-weight: 600;
}

.youtube-container {
  position: fixed;
  bottom: 0;
  right: 0;
}

.balloon-container {
  position: relative;
  width: 100%;
  height: 100dvh;
  display: grid;
  place-content: center;
}

.balloon {
  position: absolute;
  bottom: -50px; /* Start below the screen */
  right: 50%;
  width: 50px;
  height: 70px;
  border-radius: 50%;
  animation: float 8s infinite ease-in;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.balloon:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  width: 2px;
  height: 20px;
  background-color: #333;
  transform: translateX(-50%);
}

/* Balloon floating animation */
@keyframes float {
  0% {
    transform: translateX(0) translateY(0);
  }
  100% {
    transform: translateX(var(--random-x)) translateY(-100vh); /* Move upward */
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/thank_you.vue